import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Form } from 'react-bootstrap';
import Cookies from 'js-cookie';
import _ from 'lodash';
import { getOptionsByUrl } from './dynamic_select_logic';
import { Col, Row } from 'react-flexbox-grid';

const DynamicSelect = (props) => {
  const [options, setOptions] = useState([]);
  const [selectValue, setSelectValue] = useState({});
  // const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    (async function () {
      let selectStateValue = props.state[props.el.name];
      let select = props.el;
      if (_.isObject(selectStateValue)) {
        setSelectValue(selectStateValue);
      } else if (selectStateValue !== '') {
        let { type, options, url } = select.extra_attributes;
        if (type === 'manual') {
          const defaultValManual = searchDefaultValueOptions(options);
          setSelectValue(defaultValManual);
        } else {
          const optionsUrlCatalog = await getOptionsByUrl(url, '', '');
          const defaultValueUrlCatalog = searchDefaultValueOptions(optionsUrlCatalog);
          setSelectValue(defaultValueUrlCatalog);
        }
      } else {
        setSelectValue(selectStateValue);
      }
    })();
  }, [props.el]);

  function searchDefaultValueOptions(options) {
    let selectStateValue = props.state[props.el.name];
    const defualtValue = options.find((el) => el.value === selectStateValue);
    return defualtValue;
  }

  const handleChange = (selected) => {
    props.onChangeHandler(selected, props.el.name, props.el.type);
    setSelectValue(selected);
  };

  async function onFocusSelectHandler(element) {
    let dependentValues = {};
    if (element.extra_attributes.dependent_fields) {
      if (element.extra_attributes.dependent_fields.length > 0) {
        element.extra_attributes.dependent_fields.forEach((dependentField) => {
          Object.entries(props.state).forEach(([key, value]) => {
            if (key === dependentField) {
              dependentValues = { ...dependentValues, [key]: value.value };
            }
          });
        });
      }
    }
    if (element.extra_attributes.type !== 'manual') {
      setOptions([]);
      // setShowSpinner(true);
      let urlValues = '';
      Object.entries(dependentValues).forEach(([key, value]) => {
        value = value === undefined ? '' : value;
        urlValues = `${urlValues}${key}=${value}&`;
      });
      if (props.el.extra_attributes.url) {
        const options = await getOptionsByUrl(
          props.el.extra_attributes.url,
          dependentValues,
          urlValues
        );
        // setShowSpinner(false);
        setOptions(options);
      }
    } else {
      setOptions(props.el.extra_attributes.options);
    }
  }

  const customStyles = {
    control: (base) => ({
      ...base,
      minWidth: 300,
      border: props.el.error && !selectValue ? 'solid 2px #ff0000' : '',
    }),
    menu: (base) => ({
      ...base,
      position: 'absolute',
      zIndex: 2,
    }),
  };

  const customStylesDisabled = {
    control: (base) => ({
      ...base,
      backgroundColor: '#e9ecef',
      opacity: 1,
      border: '.06rem solid #c1c1c1 !important',
    }),
    singleValue: (base) => ({
      ...base,
      color: '#495057',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#495057',
    }),
  };

  const disableFieldBasedMethod = (el) => {
    const { userId_03 } = Cookies.get();

    if (el.id && el.form_id) {
      if (!el.readonly) {
        if (props.mode === 2) {
          return true;
        }
        if (props.mode === 1) {
          return false;
        } else {
          if (parseInt(userId_03) !== parseInt(props.applicant)) {
            return true;
          } else {
            if (el.observations) {
              return false;
            } else {
              return true;
            }
          }
        }
      }
    }
    if (el.readonly === 1) {
      if (props.mode === 2) {
        return true;
      }
      if (props.mode === 1) {
        return true;
      } else {
        if (parseInt(userId_03) !== parseInt(props.applicant)) {
          if (el.observations) {
            return false;
          } else {
            return true;
          }
        }
      }
    } else return false;
  };

  const validateCloudVisibility = (el) => {
    if (el.is_validable && props.mode === 3) {
      if (el.observations) {
        return { display: 'inline-block' };
      } else {
        return { display: 'none' };
      }
    } else {
      return { display: 'none' };
    }
  };

  return (
    <Col className={props.el.visibility['status'] ? '' : ' d-none'} xs={12} md={props.el.width}>
      <Row>
        <Col xs={12}>
          <Form.Group controlId={`inputForm.${props.el.name}`}>
            <Form.Label
              className={'font-weight-bold '}
              style={{ color: !props.el.error ? '#333333' : '', fontSize: '16px' }}
            >
              <span style={props.el.requiredSignal ? { display: 'inline' } : { display: 'none' }}>
                <b>* </b>
              </span>
              {props.el.label}
              <span
                className="observation-input-icon"
                style={validateCloudVisibility(props.el)}
                onClick={() => props.setShow(props.el)}
              >
                <i
                  className={'far fa-comment-dots' + (props.el.observations ? ' text-danger' : '')}
                />
              </span>
            </Form.Label>
            <Select
              value={selectValue}
              onChange={(selected) => handleChange(selected)}
              options={options}
              styles={disableFieldBasedMethod(props.el) ? customStylesDisabled : customStyles}
              isDisabled={disableFieldBasedMethod(props.el)}
              onFocus={async (e) => onFocusSelectHandler(props.el)}
            />
            <small className="form-text" style={{ fontSize: '16px', color: '#333333' }}>
              {props.el.contextual_help ? props.el.contextual_help : ''}
            </small>
            {props.el.error && !selectValue && props.errorSelect ? (
              <div className="invalid-feedback d-block" style={{ fontSize: '16px' }}>
                {props.errorSelect}
              </div>
            ) : null}
          </Form.Group>
        </Col>
      </Row>
    </Col>
  );
};

export default DynamicSelect;
